import { defineComponent as t, openBlock as r, createBlock as l, unref as p, mergeProps as m, withCtx as v, createElementVNode as a } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const s = /* @__PURE__ */ t({
  name: "IconBank",
  __name: "IconBank",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const o = n;
    return (d, e) => (r(), l(p(c), m(o, { "view-box": "0 0 24 24" }), {
      default: v(() => [...e[0] || (e[0] = [
        a("path", {
          "fill-rule": "evenodd",
          d: "M12.767 3.08a1.25 1.25 0 0 0-1.535 0L3.69 8.947c-.94.73-.423 2.236.767 2.236h15.086c1.19 0 1.707-1.506.767-2.236L12.767 3.08M5.186 9.683l6.813-5.3 6.815 5.3H5.186",
          "clip-rule": "evenodd"
        }, null, -1),
        a("path", { d: "M4 19.683a.75.75 0 0 0 0 1.5h16a.75.75 0 0 0 0-1.5H4m2-7.5a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5A.75.75 0 0 1 6 12.183m12.75.75a.75.75 0 0 0-1.5 0v5a.75.75 0 0 0 1.5 0v-5M14 12.183a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75m-3.25.75a.75.75 0 0 0-1.5 0v5a.75.75 0 0 0 1.5 0v-5" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
